package com.merkost.handpass.api.dto.admin

import kotlinx.serialization.Serializable

@Serializable
data class AdminQueueResponse(
    val data: List<AdminQueueItem> = emptyList(),
    val meta: PaginationMeta? = null,
)
